export default "__VITE_ASSET__BRWbUvy4__"